export enum MimeTypeClassifications {
  Image = 'image',
  Video = 'video',
  Document = 'document',
  Audio = 'audio',
  Archive = 'archive'
}
